import { SHELL_GEOMETRY } from "../../sections/sectionLayout";

// The agent identity gate (FarmerContextRoute VERIFYING) on rewamp mounts: breadcrumb in the shell gutter,
// body as one centred card-width column — the onboarding shape, without depending on the onboarding shell.
export const FARMER_VERIFY_PAGE_SPEC = {
  id: "FarmerVerify",
  shell: {
    geometry: SHELL_GEOMETRY.card,
    breadcrumb: true,
  },
};
